<!-- Modal -->
<div class="block mx-auto modal-box">
   <div class="modal1" id="modal-signup">
      <div class="block mx-auto boxshadow">
         <div class="row">
            <div class="col-12">
               <div class="content bank-modal-content referral-modal-content">
                  <div class="modal-header">
                     <h4 class="modal-title">{{ 'Share This Link' | translate }}</h4>
                     <button title="Close (Esc)" type="button" class="close-title" (click)="onCloseDialog()"
                        [innerHTML]="svg.closeIcon | safeHtml"></button>
                  </div>
                  <hr>
                  <div class="input-with-icon input_container">
                     <span (click)="onCopyText(referralLink, 'link')" class="copy-input">
                        <input type="text" class="form-control form-control-sm form-input-style with-copy"
                           [value]="data ? data.details.register_link : ''" readonly #referralLink>
                        <span class="input-group-append" [innerHTML]="svg.copyIcon | safeHtml"
                           (mouseenter)="$event.stopImmediatePropagation()"
                           (mouseleave)="$event.stopImmediatePropagation()" mat-raised-button #tooltipLink="matTooltip"
                           matTooltip="{{ 'Copied' | translate }}" matTooltipPosition="above">
                        </span>
                     </span>
                  </div>
                  <div class="col-12 form-group m-t-20 p-l-0 p-r-0">
                     <button class="main-button-1" (click)="onCloseDialog()">{{ 'Close' | translate }}</button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
